<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title">
        {{ $t('label.newBackground') }}
      </h3>
    </div>
    <div class="box-body">
      <background-form />
    </div>
  </div>
</template>

<script>
import BackgroundForm from './Form'

export default {
  name: 'Create',
  components: { BackgroundForm },
  metaInfo () {
    return {
      title: this.$t('string.addNewBackground'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>

</style>
